import { render, staticRenderFns } from "./SearchResultWarehouse.vue?vue&type=template&id=07440c96&scoped=true"
import script from "./SearchResultWarehouse.vue?vue&type=script&lang=js"
export * from "./SearchResultWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07440c96",
  null
  
)

export default component.exports